import type { ReactNode } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

interface SectionCardProps {
  icon: ReactNode;
  title: string;
  /** Optional descriptive text rendered under the header row. */
  subtitle?: ReactNode;
  /** Optional right-aligned header action (e.g. an Add button). */
  action?: ReactNode;
  children: ReactNode;
}

/** Bordered section container used by every card on the Profile page. */
export default function SectionCard({ icon, title, subtitle, action, children }: SectionCardProps) {
  return (
    <Card variant="outlined">
      <CardContent sx={{ p: { xs: 2.5, sm: 3 }, '&:last-child': { pb: { xs: 2.5, sm: 3 } } }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            flexWrap: 'wrap',
            mb: subtitle ? 1 : 2,
          }}
        >
          <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{ display: 'inline-flex', color: 'primary.main' }}>{icon}</Box>
            {title}
          </Typography>
          {action}
        </Box>
        {subtitle && (
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
            {subtitle}
          </Typography>
        )}
        {children}
      </CardContent>
    </Card>
  );
}
